export default __webpack_public_path__ + "static/media/cat7.778c529a.jpg";